import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { service_socketio_client } from '@/services/socketio_client_react/service_socketio_client';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { StateUser } from '../state_user';

import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';

export const remote_user_auth_magic_link_generate = createAsyncThunkSafe<DTO_RESPONSE__success | DTO_RESPONSE__error, string>(
  ENUM__network_event_client_to_server.USER_AUTH_MAGIC_LINK_GENERATE,
  async (email): Promise<DTO_RESPONSE__success | DTO_RESPONSE__error> => {
    let response = await send_to_server<DTO_RESPONSE__success | DTO_RESPONSE__error>(ENUM__network_event_client_to_server.USER_AUTH_MAGIC_LINK_GENERATE, email);

    return response;
  },
);

export function init_remote_user_auth_magic_link_generate(builder: ActionReducerMapBuilder<StateUser>) {
  builder
    .addCase(remote_user_auth_magic_link_generate.pending, state => {})
    .addCase(remote_user_auth_magic_link_generate.rejected, (state, action) => {})
    .addCase(remote_user_auth_magic_link_generate.fulfilled, (state, action: PayloadAction<DTO_RESPONSE__success | DTO_RESPONSE__error>) => {
      if (action.payload instanceof DTO_RESPONSE__error) {
        state.auth_token = '';
        state.is_authorized = false;

        service_socketio_client.is_connection_authorized = false;
      }
    });
}
